import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Animation } from '../../../theme/Animation.es.js';
import { ColorsCSS } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles } from '@zapier/style-encapsulation';
import { clamp } from '../../../utils/clamp.es.js';

const Styles = labelStyles("ProgressBar", {
  root: css({
    position: "relative",
    height: "var(--zds-size-4, 4px)",
    borderRadius: "var(--zds-radius-small, 2.5px)",
    backgroundColor: "var(--zds-background-stronger, #ECE9DF)"
  }),
  progress: (color) => [
    css({
      height: "inherit",
      borderRadius: "inherit",
      position: "absolute",
      top: 0,
      left: 0,
      maxWidth: "100%",
      transition: `all ${Animation.transitionDuration} ease-in-out`,
      backgroundColor: ColorsCSS[color]
    })
  ]
});
const ProgressBar = (_a) => {
  var { max = 1, min = 0, color = "blue" } = _a, props = __rest(_a, ["max", "min", "color"]);
  const value = clamp(props.value, min, max);
  const range = max - min;
  const decimal = (value - min) / range;
  const width = `${decimal * 100}%`;
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    jsx("div", { css: Styles.progress(color), "data-testid": "progress", "data-zds": true, style: {
      width
    } })
  );
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.es.js.map
